// extracted by mini-css-extract-plugin
export default {"event_info":"styles_event_info__BlgSS","event_info_inputs":"styles_event_info_inputs__HVRSa","event_type_select_box":"styles_event_type_select_box__iI0TD"};